import { Login, PreLogin } from '@you-go-vn/components';
import LockIcon from '@you-go-vn/components/src/Common/Icons/LockIcon';
import WarningIconAuth from '@you-go-vn/components/src/Common/Icons/WarningIconAuth';
import ModalDialog from '@you-go-vn/components/src/Common/Modal/ModalDialog';
import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../store';
import { MessageType, setAuthenInfo } from '../../store/authenInfoSlice';
import { clearMessage } from '../../store/messageSlice';
import { authService, LoginParams } from '../auth/services';
import { loginDispatch } from '../profile/slide';
import { StatusAccount } from './type';

function LoginPage() {
  const dispatch = useAppDispatch();
  const { isLoading } = useAppSelector((state) => state.user);
  const { isPreLogin, type, messageError, countWrong } = useAppSelector(
    (state) => state.authenInfo,
  );

  const [isInactive, setIsInactive] = useState(false);
  const [isError, setIsError] = useState(false);

  const [isPreLoading, setIsPreLoading] = useState(false);
  const [currEmail, setCurrEmail] = useState('');

  useEffect(() => {
    dispatch(clearMessage());
    // dispatch(clearMessage());
  }, [dispatch]);

  const onPreLogin = async (body: { email: string }) => {
    setIsPreLoading(true);
    dispatch(setAuthenInfo({ email: body.email, password: '' }));
    try {
      const res = await authService.preLogin(body);
      if (res?.data?.message === 'success') {
        if (res?.data?.data?.status === StatusAccount.INACTIVE) {
          setIsInactive(true);
        } else {
          setCurrEmail(body.email);
          dispatch(
            setAuthenInfo({
              email: body.email,
              password: '',
              isPreLogin: true,
            }),
          );
        }
      }
    } catch (error: any) {
      setIsError(true);
    } finally {
      setIsPreLoading(false);
    }
  };

  const renderHeading = (type: MessageType) => { 
    if (type === MessageType.LOCK) {
      return 'Tài khoản đang bị hạn chế đăng nhập';
    }

    if (type === MessageType.WARNING) {
      return 'Đăng nhập chưa chính xác';
    }

    if (type === MessageType.NORMAL) {
      return messageError;
    }
  };
  
  return (
    <>
      {!isPreLogin ? (
        <PreLogin
          onSubmit={(value: { email: string }) => onPreLogin(value)}
          isSubmiting={isPreLoading}
          showLinkForgotPassword
          isAccInactive={isInactive}
          isError={isError}
          closeErrorModal={() => setIsError(false)}
          closeInactiveModal={() => setIsInactive(false)}
        />
      ) : (
        <Login
          onSubmit={(value: LoginParams) => {
            dispatch(loginDispatch(value));
          }}
          isSubmiting={isLoading}
          showLinkForgotPassword
          currentEmail={currEmail}
        />
      )}
      <ModalDialog
        visible={messageError ? true : false}
        type="warning"
        icon={type === MessageType.LOCK ? <LockIcon /> : <WarningIconAuth />}
        heading={type !== undefined ? renderHeading(type) : ''}
        onClose={() =>
          dispatch(setAuthenInfo({ messageError: '', isPreLogin: true }))
        }
        confirm={true}
        confirmText="Tôi đã hiểu"
        onConfirm={() =>
          dispatch(setAuthenInfo({ messageError: '', isPreLogin: true }))
        }
        subMessage={
          type === MessageType.WARNING
            ? `Vui lòng kiểm tra lại thông tin đăng nhập. Bạn còn ${
                countWrong ? 5 - countWrong : 0
              } lần thử lại trong ngày hôm nay.`
            : undefined
        }
      />
    </>
  );
}

export default LoginPage;
